// extracted by mini-css-extract-plugin
export default {"error":"error-boundary_error__rmyXh","text":"error-boundary_text__TtsPb","reloadBtn":"error-boundary_reloadBtn__94oPp"};